import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons'
var striptags = require('striptags');

function ErrorMessage(props){
    // console.table(props);
    return(
        <div className="w-full mb-5 p-4 bg-garfield-bg-danger grid grid-cols-6 gap-4 justify-items-center items-center">
                <FontAwesomeIcon icon={faTimesCircle} className="text-white self-center" size="2x" aria-hidden="true" />
                <ul className="w-full col-span-2" >
                    {props.error.map((data, key) => {
                        let message = data.message? data.message: data
                        return(
                            <li className="w-full col-span-6" key={key}>{striptags(message)}</li>
                        )
                    })}
                </ul>    
        </div>
    )
}

export default ErrorMessage;